<template>
    <div class="container" style="background-color: #eeeeee;padding-bottom: 100px;">
        <img src="../../../assets/banner3.png" alt="">
        <div class="main">
            <!-- <Breadcrumb /> -->
            <ul class="Breadcrumb">
                <li @click="backPage('/home')">首页</li>
                <li>></li>
                <li @click="backPage('/product/index')">产品中心</li>
                <li>></li>
                <li @click="backPage('-1')">{{ detail.name }}</li>
                <li>></li>
                <li>产品视频</li>
            </ul>
            <div>
                <h3 class="tab_title">{{ detail.name }}</h3>
                <div style="width:1000px" class="fleft">
                    <div style="cursor: pointer;">
                        <video ref="video" :poster="detail.coverImage" style="width:100%" muted="muted" class="video"
                            :src="detail.video" type="video/mp4" controls="controls">
                            <p>你的浏览器不支持video标签.</p>
                        </video>
                        <!-- <img :src="detail.coverImage" alt=""> -->
                    </div>
                    <div style="margin-top:10px;" class="editor" v-html="detail.description"></div>
                </div>
                <div style="width:180px" class="fright">
                    <h3>相关信息</h3>
                    <ul>
                        <li @click="back">{{ detail.name }}</li>
                    </ul>
                </div>
            </div>
           
        </div>
        <video-box class="videobox" v-show="showVideo" :videoUrl="videoUrl"></video-box>
    </div>
</template>
<script>
import { getVideoDetail } from '@/api/index'
import videoBox from '../../fwzc/video.vue'
import {backPage} from '@/utils/common'
export default {
    components: {
        videoBox
        // Menu
    },
    data() {
        return {
            name: "",
            detail: {},
            showVideo: false,
            videoUrl: ""
        }
    },
    mounted() {
        getVideoDetail(this.$route.query.id).then(res => {
            this.detail = res.data
        })
    },
    methods: {
        checkViedo(url) {
            console.log(url);
            this.showVideo = true
            this.videoUrl = url
        },
        back(){
            this.$router.back()
            document.documentElement.scrollTop = 0;
        },
        backPage
    }

}
</script>
<style scoped lang="scss">
.videobox {
    position: fixed;
    top: 140px;
    left: 20%;
    width: 60%;
    height: 700px;
}

.main {
    overflow: hidden;
}

.fright {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;

    h3 {
        line-height: 60px;
        font-size: 20px;
        font-weight: bold;
        border-bottom: 1px solid #eee;
    }
    ul{
        li{
            color: #245198;
            line-height: 40px;
            font-weight: bold;
            font-size: 16px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/center/compontents/productVideo.vue